import React from 'react';

export function LogoMarca({ style, onClick }: { style?: React.CSSProperties; onClick?: () => void }) {
  // SVG principal da marca Currículo Popular
  return (
    <img src={"/assets/logo-fundo-transparente.png"} alt="Logo Currículo Popular" style={{ width: 180, ...style }} onClick={onClick} />
  );
}

export function IconeMarca({ style, index = 1 }: { style?: React.CSSProperties; index?: number }) {
  // Renderiza um dos ícones SVG da pasta Iconografia
  const iconMap = {
    1: "/assets/icones-curriculo-01.svg",
    2: "/assets/icones-curriculo-02.svg",
    3: "/assets/icones-curriculo-03.svg",
    4: "/assets/icones-curriculo-04.svg",
    5: "/assets/icones-curriculo-05.svg",
    6: "/assets/icones-curriculo-06.svg",
  };
  return (
    <img src={iconMap[index]} alt={`Ícone Currículo Popular ${index}`} style={{ width: 48, ...style }} />
  );
}
